import Fa from "./Translation/Fa.json";
import En from "./Translation/En.json";
import i18n from "i18next";

import { SetStorage } from "./Utils/Storage";
import { initReactI18next } from "react-i18next";

const resources = {
  fa: {
    translation: Fa,
  },
  en: {
    translation: En,
  },
};

SetStorage("LNG", "EN", "local");

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

